import { Component} from '@angular/core';
import {ClientService} from "./shared/services/client.service";
import {LoaderService} from "./shared/services/loader.service";
import {LocalizationService} from "./shared/services/localization.service";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  constructor(public loaderService: LoaderService, private localizationService: LocalizationService) {
  }
}
